import { Injectable } from "@angular/core";
import{ Http, Headers } from "@angular/http";
import { map } from 'rxjs/operators';
import { GLOBAL } from './global';

@Injectable()
export class Seguimiento_cert_Service {
  [x: string]: any;
    
    public url;
    public identity;
    public token;
    constructor(private _http: Http){
        this.url = GLOBAL.url;
    }
    

    getSolicitudes(rut){
        console.log('3');
        let params = {
            rut: rut 
        };
        console.log('4');
        let headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        console.log('5');
        return this._http.post(this.url+'seguimiento_solicitudes', params, {headers: headers})
        .pipe(map(res => res.json()));
    }

     getCert(rut, numero){
        console.log('a');
        let params = {
            rut: rut, 
            num_solicitud:numero
        };
        console.log('b');
        let headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        console.log('c');
        return this._http.post(this.url+'seguimiento_certificado', params, {headers: headers})
        .pipe(map(res => res.json()));
    }


    getSolicitud(id){

        var params = {
            id: id
        }
        let headers = new Headers({
            'Content-type': 'application/json',
        });

        return this._http.post(this.url + 'seguimiento_solicitudes', params, {headers: headers})
        .pipe(map(res => res.json()));
    }
   

}